import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

class DeleteModal extends React.Component {
  render() {
    const { show, onHide, onConfirm } = this.props;
    if (!show) return null;

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header className="bg-danger text-white">
          <Modal.Title><FaTrash style={{ marginRight: '8px' }}/> Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure? This cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={onHide}>Cancel</Button>
          <Button variant="danger" onClick={onConfirm}>Delete</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default DeleteModal;